<script lang="ts">
  import { productTypesQuery } from '$lib/queries/products';

  // Read-only — product types are synced from ProQuote.
  const productTypes = productTypesQuery();
</script>

<div>
  <table class=" text-center min-w-full divide-y divide-blue-100">
    <thead class="bg-blue-50">
      <tr>
        <th class="">Name</th>
        <th class="">Category</th>
        <th class="">Description</th>
      </tr>
    </thead>
    <tbody>
      {#each productTypes.data ?? [] as productType}
        <tr>
          <td class="">{productType.name}</td>
          <td class="">{productType.category_name}</td>
          <td class="">{productType.description}</td>
        </tr>
      {/each}
    </tbody>
  </table>
</div>
